module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ke-La.bd4b6df1.png";